import { signInWithPopup, Auth, AuthProvider } from 'firebase/auth'

export const authenticateUser = async (auth: Auth, provider: AuthProvider) => {
  auth.useDeviceLanguage()
  return signInWithPopup(auth, provider)
}
